module.exports = __webpack_public_path__ + "img/20190720122224280.198d2cb9.png";